import App from "./App";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { store } from "./store/configStore";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

ReactDOM.render(
  <React.StrictMode>
    <link rel="stylesheet" href="/adminlte/preq/bootstrap/dist/css/bootstrap.css" />
    <link rel="stylesheet" href="/adminlte/preq/font-awesome/css/font-awesome.min.css" />
    <link rel="stylesheet" href="/adminlte/css/AdminLTE.css" />
    <link rel="stylesheet" href="/adminlte/css/skins/_all-skins.min.css" />
    <link rel="stylesheet" href="/adminlte/style.css?version=32920221222" />
    <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,600,700,300italic,400italic,600italic" />

    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
